<template>
  <div>
    <b-modal
            centered
            hide-footer
            v-model="modalPOP.draftStorage" 
            size="lg" 
        >
            <template slot="modal-header">
              <div slot="header">
                <h4>ฉบับร่างทั้งหมด</h4>
              </div>
              <div slot="close">
                <span>
                  <img class="cursor-pointer" :src="icon.close.url" @click="close('draftStorage')" alt="">
                </span>
              </div>
            </template>
            <div class="container-fluid">
                <div class="row">
                   <div class="col-12">
                    <template>
                      <b-table
                          show-empty
                          empty-text="ไม่มีข้อมูลฉบับร่าง"
                          :items="draftStorage"
                          :fields="fieldsArea"
                          responsive
                          class="scroll-bar-pop"
                      >
                          <template slot="sort_index" slot-scope="row">
                             {{ row.index+=1 }}
                          </template>
                          <template slot="date_created" slot-scope="row">
                             {{ row.item.date_created }}
                          </template>
                          <template slot="name" slot-scope="row">
                             คุณ {{ row.item.name }}
                          </template>
                          <template slot="total_orders" slot-scope="row">
                             {{ row.item.total_orders }}
                          </template>
                          <template slot="actions" slot-scope="row">
                              <button
                                  class="btn btn-sm btn-info px-3"
                                  :class="checkDisable(row.item.key) ? 'disabled' : '' "
                                  @click="SwapLocalStorage(row.item.key)"
                              >ทำรายการต่อ</button>
                              <button
                                  class="btn btn-sm btn-danger px-3"
                                  @click="emitDeleteDraft(row.item.key)"
                              >ลบ</button>
                          </template>
                      </b-table>
                    </template>
                   </div>
                </div>
            </div>
        </b-modal>
  </div>
</template>

<script>
import cartPos from '@/constants/CartPos';
export default {
  props: {
    modalPOP: Object,
    draftStorage: Array,
  },
  data() {
    return {
      icon: {
        close: {
          url: require("../../assets/icon/close.svg")
        }
      },
    }
  },
  computed:{
        fieldsArea(){
            let fields = [
              { key: "sort_index", label: "ลำดับ", sortable: false },
              { key: "date_created", label: "วันที่สร้างรายการ", sortable: true },
              { key: "name", label: "ชื่อผู้ส่ง", sortable: true },
              { key: "total_orders", label: "จำนวนพัสดุ", sortable: true },
              { key: "actions", label: "การจัดการ", sortable: false }
            ]
            return fields
        },
    },
    methods: {
      close(key) {
        return this.$emit('closeModal', key)
      },
      SwapLocalStorage(key) {
        return this.$emit('resumeDraftSelect', key)
      },
      emitDeleteDraft(key) {
        return this.$emit('deleteOrderDraft', key)
      },
      checkDisable(key) {
        const getCartToken = cartPos.cartToken().get()
        return key === getCartToken ? true : false
      }
    }
}
</script>